<template>
  <div v-if="isLoading">
    <va-loading size="lg" color="#3E4095" center></va-loading>
  </div>
  <div v-else class="detail-course-container">
    <va-row :gutter="28">
      <va-column :xs="12" :sm="12" :md="8">
        <template v-if="nowPlaying">
          <div class="video-container">
            <VideoPlayer :video="nowPlaying" :key="nowPlaying._id" />
          </div>
          <div
            class="flex flex-col md:flex-row items-start md:items-center justify-start md:justify-between my-4"
          >
            <div class="">
              <h3>{{ nowPlaying.name }}</h3>
              <div class="subheading">
                <h5>
                  {{
                    nowPlaying.videoDuration
                      ? parseDuration(nowPlaying.videoDuration)
                      : "Akan Datang"
                  }}
                </h5>
              </div>
            </div>
            <div>
              <va-button v-if="isFinishedLesson(nowPlaying._id)" type="success"
                >Materi Telah Selesai</va-button
              >
              <va-button v-else @click.prevent="finishedLesson" type="subtle"
                >Selesaikan</va-button
              >
            </div>
          </div>
          <hr class="th-border" />
          <section>
            <div
              v-html="nowPlaying.description"
              class="th-text-paragraph"
            ></div>
          </section>
        </template>
      </va-column>
      <va-column :xs="12" :sm="12" :md="4">
        <div class="th-card course-section-container">
          <div
            class="course-section"
            v-for="section in courseSections"
            :key="section.name"
          >
            <h5 class="th-font-weight-bold">{{ section.name }}</h5>
            <template v-for="lesson in section.lessons">
              <ListLesson
                :lessonActive="nowPlaying._id"
                :lesson="lesson"
                :lessonLogs="lessonLogs"
                :key="lesson._id"
                @play-video="setPlaying"
              />
            </template>
          </div>
        </div>
        <section v-if="detailCourse">
          <div v-if="!reviewExist" class="th-card rating-container">
            <div>
              <h4>Bagaimana dengan kelas ini?</h4>
              <p>Silahkan berikan ulasan anda tentang kelas ini</p>
            </div>
            <va-button @click.prevent="modalUlasanToggle" type="primary" block
              >Beri Ulasan</va-button
            >
            <va-modal :backdrop-clickable="false" ref="customModal">
              <div slot="header" />
              <div class="modal-body" slot="body">
                <div class="content">
                  <h3>Ulasan Anda</h3>
                  <star-rating
                    :rating="0"
                    :star-size="50"
                    :show-rating="false"
                    :rounded-corners="true"
                    v-model="formReview.rating"
                  />
                  <va-textarea
                    v-model="formReview.description"
                    :resize="false"
                    width="100%"
                    minHeight="200px"
                    :readonly="false"
                    :disabled="false"
                  >
                  </va-textarea>
                </div>
              </div>
              <div class="modal-body" slot="footer">
                <div style="text-align: right">
                  <va-button type="subtle" @click="$refs.customModal.close()"
                    >Batal</va-button
                  >
                  <va-button type="primary" @click="sendReview"
                    >Kirim Ulasan</va-button
                  >
                </div>
              </div>
            </va-modal>
          </div>
        </section>
      </va-column>
    </va-row>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import parseDuration from '@/helpers/videoDuration'
const VideoPlayer = () => import('@/components/Shared/VideoPlayer')
const ListLesson = () => import('@/components/Shared/ListLesson/2')
// const courseSection = [
//   {
//     name: 'Gambaran Course',
//     totalLesson: 1,
//     lessons: [
//       {
//         id: 1,
//         name: 'Trailer',
//         duration: '1m 15s',
//         isLock: false,
//         isFinished: true,
//       },
//     ],
//   },
//   {
//     name: 'Memulai Kajian Kitab Tadzkiatun Nafs',
//     totalLesson: 4,
//     lessons: [
//       {
//         id: 2,
//         name: 'Perkenalan',
//         duration: '3m 45s',
//         isLock: false,
//       },
//       {
//         id: 3,
//         name: 'Menjelaskan Tentang Kitab Tadzkiatun Nafs (PART 1)',
//         duration: '50m 27s',
//         isLock: true,
//         isFinished: true,
//       },
//       {
//         id: 4,
//         name: 'Menjelaskan Tentang Kitab Tadzkiatun Nafs (PART 2)',
//         duration: null,
//         isLock: true,
//       },
//     ],
//   },
// ]
export default {
  components: {
    StarRating,
    VideoPlayer,
    ListLesson,
  },
  data() {
    return {
      myCourseId: null,
      lessonLogs: [],
      courseSections: [],
      detailCourse: null,
      lessonActive: '',
      ulasan: '',
      nowPlaying: null,
      formReview: {
        rating: null,
        description: null,
      },
      reviewExist: false,
    }
  },
  methods: {
    parseDuration,
    isFinishedLesson(key) {
      return Boolean(this.lessonLogs.find(lesson => lesson._id === key && lesson.status === 'finished'))
    },
    finishedLesson() {
      this.$store.dispatch('course/POST_FINISHED_LESSON', { myCourseId: this.myCourseId, lessonId: this.nowPlaying._id, status: 'finished' })
        .then(_ => {
          this.fetchDetailCourse(false)
        })
    },
    modalUlasanToggle() {
      this.$refs.customModal.open()
    },
    setPlaying(params = { first: true, selectedLesson: {} }) {
      let lesson = {
        poster: '',
        videoUrl: '',
      }
      if (this.courseSections.length) {
        if (params.first) {
          const target = this.courseSections.flatMap(section => section.lessons).find(lesson => !lesson.isLocked && lesson.videoUrl)
          if (target) {
            lesson = target
          }
        } else {
          lesson = params.selectedLesson
        }
      }
      this.nowPlaying = lesson
    },
    sendReview() {
      const id = this.$route.params.id
      const dataBody = this.formReview
      if (!dataBody.rating || !dataBody.description) {
        this.notification.warning({
          title: 'Gagal Mengirim Ulasan',
          message: 'Pastikan anda mengisi kolom rating dan deskripsi',
          duration: 2000,
        })
        this.$refs.customModal.close()
        setTimeout(() => {
          this.$refs.customModal.open()
        }, 2000)
      } else {
        this.$store.dispatch('course/POST_REVIEW_COURSE', { id, dataBody })
          .then(_ => {
            this.$refs.customModal.close()
            this.fetchStatusReviewExist(id)
            this.notification.success({
              title: 'Berhasil Mengirim Ulasan',
              message: 'Terima Kasih sudah memberikan ulasan anda terhadap kelas ini',
              duration: 5000,
            })
          })
          .catch(_ => {
            this.notification.danger({
              title: 'Gagal Mengirim Ulasan',
              message: 'Mohon Maaf ulasan anda gagal dikirim',
              duration: 5000,
            })
          })
      }
    },
    fetchStatusReviewExist(id) {
      this.$store.dispatch('course/FETCH_STATUS_REVIEW_EXIST_MYCOURSE', { id })
        .then(res => {
          if (res) {
            this.reviewExist = res
          }
        })
    },
    fetchDetailCourse(first = true) {
      const id = this.$route.params.id
      this.$store.dispatch('course/FETCH_DETAIL_MYCOURSE_BY_ID', { id })
        .then(res => {
          this.fetchStatusReviewExist(id)
          this.myCourseId = res._id
          this.lessonLogs = res.lessonLogs
          this.detailCourse = res.courseId
          this.courseSections = res.courseId.sections
          this.setPlaying({ first, selectedLesson: first ? {} : this.nowPlaying })
        })
    },
  },
  mounted() {
    this.fetchDetailCourse()
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading
    },
  },
}
</script>

<style lang="scss">
.detail-course-container {
  .video-container {
    border-radius: 4px;
    overflow: hidden;
  }

  .header {
    margin: 16px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (min-width: 768px) {
      & {
        flex-direction: row;
        justify-content: space-between;
      }
    }

    .subheading {
      display: inline-flex;
      gap: 12px;
      align-items: center;
    }
  }

  .course-section-container {
    height: 550px;
    max-height: 550px;
    padding: 25px 16px 16px 16px;
    overflow-x: hidden;
    overflow-y: auto;
    .course-section {
      margin-bottom: 35px;
    }
  }

  .rating-container {
    padding: 18px 16px 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  section {
    margin-top: 30px;
  }
}

.modal-body {
  padding: 24px;

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 35px;

    .vue-star-rating {
      // gap: 15px;
    }
  }
}
</style>
